import { createSlice } from '@reduxjs/toolkit';

import type { BusStopInfo } from '@/types/busStopInfo';

const initialState: BusStopInfo = {
  id: '',
  busStopName: '',
  location: {
    latitude: 0,
    longitude: 0,
  },
  previousStop: {
    right: '',
    left: '',
    center: '',
    rightAutoVehicle: '',
    leftAutoVehicle: '',
    rightLabel: '',
    leftLabel: '',
  },
  timer: {
    right: 0,
    left: 0,
    center: 0,
    rightAutoVehicleTimer: 0,
    leftAutoVehicleTimer: 0,
    deadTime: 0,
    deadTimeZones: [],
  },
  geofence: {
    point: [0, 0],
    radius: 0,
    id: '',
  },
};

interface BusStopInfoPayload {
  // TODO
  id: string;
  name: string;
  location: {
    geometry: {
      coordinates: [number, number];
    };
  };

  attributes: {
    left: string;
    right: string;
    center: string;
    rightAutoVehicle?: string;
    leftAutoVehicle?: string;
    leftTimer: number;
    rightTimer: number;
    centerTimer: number;
    rightAutoVehicleTimer?: number;
    leftAutoVehicleTimer?: number;
    deadTime?: number;
    deadTime1Position?: string;
    deadTime1StartTime?: string;
    deadTime1EndTime?: string;
    deadTime2Position?: string;
    deadTime2StartTime?: string;
    deadTime2EndTime?: string;
    deadTime3Position?: string;
    deadTime3StartTime?: string;
    deadTime3EndTime?: string;
    deadTime4Position?: string;
    deadTime4StartTime?: string;
    deadTime4EndTime?: string;
    rightLabel?: string;
    leftLabel?: string;
  };
}

export const busStopInfoSlice = createSlice({
  name: ' busStopInfo',
  initialState,
  reducers: {
    setBusStopId(state, action) {
      state.id = action.payload;
    },

    setBusStopInfo: (state, { payload }: { payload: BusStopInfoPayload }) => {
      // TODO: ここにactionの型を入れても良い
      state.busStopName = payload.name;
      state.location.latitude = payload.location.geometry.coordinates[1];
      state.location.longitude = payload.location.geometry.coordinates[0];
      state.previousStop.right = payload.attributes.right;
      state.previousStop.left = payload.attributes.left;
      state.previousStop.center = payload.attributes.center;
      state.previousStop.rightAutoVehicle =
        payload.attributes.rightAutoVehicle ?? '';
      state.previousStop.leftAutoVehicle =
        payload.attributes.leftAutoVehicle ?? '';
      state.previousStop.rightLabel = payload.attributes.rightLabel ?? '';
      state.previousStop.leftLabel = payload.attributes.leftLabel ?? '';
      state.timer.right = payload.attributes.rightTimer;
      state.timer.left = payload.attributes.leftTimer;
      state.timer.center = payload.attributes.centerTimer;
      state.timer.rightAutoVehicleTimer =
        payload.attributes.rightAutoVehicleTimer ?? 0;
      state.timer.leftAutoVehicleTimer =
        payload.attributes.leftAutoVehicleTimer ?? 0;

      state.timer.deadTime = payload.attributes.deadTime;

      if (payload.attributes.deadTime1Position !== undefined) {
        state.timer.deadTimeZones.push({
          position: payload.attributes.deadTime1Position ?? '',
          startTime: payload.attributes.deadTime1StartTime ?? '',
          endTime: payload.attributes.deadTime1EndTime ?? '',
        });
      }

      if (payload.attributes.deadTime2Position !== undefined) {
        state.timer.deadTimeZones.push({
          position: payload.attributes.deadTime2Position ?? '',
          startTime: payload.attributes.deadTime2StartTime ?? '',
          endTime: payload.attributes.deadTime2EndTime ?? '',
        });
      }

      if (payload.attributes.deadTime3Position !== undefined) {
        state.timer.deadTimeZones.push({
          position: payload.attributes.deadTime3Position ?? '',
          startTime: payload.attributes.deadTime3StartTime ?? '',
          endTime: payload.attributes.deadTime3EndTime ?? '',
        });
      }

      if (payload.attributes.deadTime4Position !== undefined) {
        state.timer.deadTimeZones.push({
          position: payload.attributes.deadTime4Position ?? '',
          startTime: payload.attributes.deadTime4StartTime ?? '',
          endTime: payload.attributes.deadTime4EndTime ?? '',
        });
      }
    },

    setGeofence: (state, action) => {
      state.geofence.point = action.payload.point;
      state.geofence.radius = action.payload.radius;
      state.geofence.id = action.payload.id;
    },
  },
});

export const {
  reducer: busStopInfoReducer,
  actions: { setBusStopId, setBusStopInfo, setGeofence },
} = busStopInfoSlice;
